module.exports = __webpack_public_path__ + "static/media/Pre-Orientation-Grazery-20180827028-SS-.ceddaf10.jpg";